// again-why-vis.js — Shift's feature loops inside the PDP "why it works" blocks (sections/again-why.liquid).
// Same contract as the home tiles (agh-loop in again-home.js): the <video> ships with preload="none", no
// autoplay and no src (data-src), so nothing downloads until the block is on screen. First intersect →
// set src + play; off screen → pause. Reduced motion or no IntersectionObserver → never loads, the
// static poster stays.
class AgWhyLoop extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video || this._io || !('IntersectionObserver' in window)) return;
    video.muted = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this._io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !reduce.matches) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
              video.preload = 'auto';
            }
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else if (video.src) {
            video.pause();
          }
        });
      },
      { threshold: 0.2 }
    );
    this._io.observe(this);
  }
  disconnectedCallback() {
    this._io?.disconnect();
    this._io = null;
  }
}
if (!customElements.get('ag-why-loop')) customElements.define('ag-why-loop', AgWhyLoop);
